import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { StoreProvider } from "./context/StoreContext";
import { Toaster } from "./components/ui/toaster";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Articulos from "./pages/Articulos";
import ArticuloDetalle from "./pages/ArticuloDetalle";
import Cursos from "./pages/Cursos";
import Comunidad from "./pages/Comunidad";
import Sesiones from "./pages/Sesiones";
import Membresia from "./pages/Membresia";
import Login from "./pages/Login";
import Registro from "./pages/Registro";
import Admin from "./pages/Admin";
import CheckoutSuccess from "./pages/CheckoutSuccess";

function MemberRoute({ children }) {
  const { isMember, isAuthenticated, loading } = useAuth();
  if (loading) return <div className="min-h-[60vh]" />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isMember) return <Navigate to="/membresia" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { isAdmin, loading } = useAuth();
  if (loading) return <div className="min-h-[60vh]" />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App font-body">
      <AuthProvider>
        <StoreProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/articulos" element={<Articulos />} />
                <Route path="/articulos/:id" element={<ArticuloDetalle />} />
                <Route path="/membresia" element={<Membresia />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/login" element={<Login />} />
                <Route path="/registro" element={<Registro />} />
                <Route
                  path="/cursos"
                  element={
                    <MemberRoute>
                      <Cursos />
                    </MemberRoute>
                  }
                />
                <Route
                  path="/comunidad"
                  element={
                    <MemberRoute>
                      <Comunidad />
                    </MemberRoute>
                  }
                />
                <Route
                  path="/sesiones"
                  element={
                    <MemberRoute>
                      <Sesiones />
                    </MemberRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <AdminRoute>
                      <Admin />
                    </AdminRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </BrowserRouter>
          <Toaster />
        </StoreProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
